<template>
  <div>
    <b-row class="d-flex justify-content-between">
      <b-col cols="1">
        <label>{{$t('labels.common.excel_reports')}}</label>
      </b-col>
      <b-col cols="3">
        <multiselect v-model="excel_report" :max-height="200"
                     placeholder="Choose report" label="value" track-by="value"
                     :options="reports" :multiple="false"
                     @select="loadExcelReport"
                     :taggable="true" :close-on-select="true"></multiselect>
      </b-col>
      <b-col class="d-flex justify-content-end button-group">
        <img v-if="currentRoutePermissions.add_partnerpayment"
             src="@/assets/images/common-icons/icon_create.svg" @click="create"
             :title="$t('buttons.payments.create_payment')">
        <img v-if="currentRoutePermissions.delete_partnerpayment"
             src="@/assets/images/common-icons/icon_delete.svg" @click="deletePayments"
             :title="$t('buttons.payments.delete_payments')">
        <img src="@/assets/images/common-icons/icon_clear.png" @click="cleanFilters"
             :title="$t('buttons.common.clear_filters')">
        <img src="@/assets/images/common-icons/icon_search.svg" @click="search"
             :title="$t('buttons.common.search')">
      </b-col>
    </b-row>
    <div class="search-form">
      <div class="search-form__filters">
        <b-row>
          <b-col>
            <label>{{$t('labels.payments.payment_date')}}</label>
            <range-date-picker v-model="searchData.rangeDate" range lang="en"
                               range-separator="/" :first-day-of-week="1"></range-date-picker>
          </b-col>
          <b-col>
            <label>{{$t('labels.payments.payment_status')}}</label>
            <multiselect v-model="searchData.statuses" :max-height="200"
                         placeholder="Choose payment statuses" label="text" track-by="text"
                         :options="statuses" :multiple="true"
                         :taggable="true" :close-on-select="false"></multiselect>
          </b-col>
          <b-col>
            <label>{{$t('labels.common.payer')}}</label>
            <multiselect v-model="searchData.payers" :max-height="200"
                         placeholder="Choose payers" label="name" track-by="name"
                         :options="partners" :multiple="true"
                         :taggable="true" :close-on-select="false"></multiselect>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>{{$t('labels.payments.payment_type')}}</label>
            <multiselect v-model="searchData.money_flow" :max-height="200"
                         placeholder="Choose payment types"
                         :options="money_flow" :multiple="true"
                         :taggable="true" :close-on-select="false"></multiselect>
          </b-col>
          <b-col>
            <label>{{$t('labels.payments.payment_number')}}</label>
            <input class="form-control" v-model="searchData.payment_number"
                   placeholder="Enter payment No">
          </b-col>
          <b-col>
            <label>{{$t('labels.common.recipient')}}</label>
            <multiselect v-model="searchData.recipients" :max-height="200"
                         placeholder="Choose recipients" label="name" track-by="name"
                         :options="partners" :multiple="true"
                         :taggable="true" :close-on-select="false"></multiselect>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="4">
            <label>{{$t('labels.payments.payment_sum')}}</label>
            <float-input v-model="searchData.total" placeholder="Enter payment sum"></float-input>
          </b-col>
          <b-col cols="4">
            <label>{{$t('labels.common.currency')}}</label>
            <multiselect v-model="searchData.currencies" :max-height="200"
                         placeholder="Choose currencies" label="code" track-by="code"
                         :options="currencies" :multiple="true"
                         :taggable="true" :close-on-select="false"></multiselect>
          </b-col>
          <b-col>
            <label>{{$t('labels.payments.payment_method')}}</label>
            <multiselect v-model="searchData.payment_type" :max-height="200"
                         placeholder="Choose payment method" label="text" track-by="text"
                         :options="payment_type" :multiple="true"
                         :taggable="true" :close-on-select="false"></multiselect>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="4">
            <label>{{$t('labels.payments.refund')}}</label>
            <multiselect v-model="searchData.refund" :max-height="200"
                         placeholder="Choose payment method"
                         :options="refund" :multiple="false" label="text" track-by="text"
                         :taggable="true" :close-on-select="true"></multiselect>
          </b-col>
          <b-col cols="4">
            <label>{{$t('labels.payments.lc_costs')}}</label>
            <multiselect v-model="searchData.zero_lc" :max-height="200"
                         placeholder="Choose L/C costs"
                         :options="lc_costs" :multiple="false" label="text" track-by="text"
                         :taggable="true" :close-on-select="true">

            </multiselect>
          </b-col>
          <b-col>
            <label>{{$t('labels.payments.payment_form')}}</label>
            <multiselect v-model="searchData.mode" :max-height="200"
                         placeholder="Choose payment form" label="name" track-by="name"
                         :options="paymentForms" :multiple="true"
                         :close-on-select="false"></multiselect>
          </b-col>
        </b-row>
      </div>
      <div>
        <b-row>
          <b-col cols="4">
            <input class="form-control"
                   placeholder="Filter..."
                   @input="setQuickFilter">
          </b-col>
          <b-col cols="4" offset="4" class="vertical-center-container justify-content-end">
            <label for="pagination-toggle" class="margin-right-5">Pagination</label>
            <input id="pagination-toggle" type="checkbox"
                   title="this checkbox needed for toggle pagination bar" v-model="paginationState"
                   @change="togglePagination">
            <save-columns-btn :grid="gridOptions" :grid-name="gridName"
                              class="margin-left-5"></save-columns-btn>
          </b-col>
        </b-row>
      </div>
    </div>
    <div>
      <b-row>
        <b-col>
          <ag-grid-vue class="ag-theme-balham grid" :gridOptions="gridOptions"
                       @rowDoubleClicked="goToPayment" :postProcessPopup="postProcessPopup"
                       @gridReady="search" :columnDefs="columns" :rowData="payments"
                       @filterChanged="updateTotalData"
                       :pinnedBottomRowData="totalData">
          </ag-grid-vue>
        </b-col>
      </b-row>
      <b-row class="pagination__wrapper" v-if="paginationState">
        <b-col cols="5">
          <div class="pagination-info">{{countOfViewPayments}} {{$t('common_content.of')}} {{paymentsCount}}
          </div>
        </b-col>
        <b-col cols="7">
          <b-pagination size="md" :total-rows="paymentsCount" :per-page="searchObject.limit"
                        v-model="currentPaginateIndex"
                        @input="changePaginateState"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import { AgGridVue } from 'ag-grid-vue';
  import { mapGetters, mapState } from 'vuex';
  import Multiselect from 'vue-multiselect';
  import RangeDatePicker from 'vue2-datepicker'
  import {
    cleanFilters,
    saveFilters,
    setFilters,
    checkSavedFilterData,
    getArrayByProperty,
    setNotifyData,
    getFileNameFromContentDisposition,
    transformDateFromDateRangeToStringFormatByIndex
  } from '@/helpers/commonHelpers';
  import FloatInput from '@/components/common/FloatInput'
  import SaveColumnsBtn from '@/components/common/SaveColumnsBtn';
  import { saveAs } from 'file-saver';
  import { gridMixins, updateTotalDataMixin } from '@/mixins';

  export default {
    mixins: [gridMixins, updateTotalDataMixin],
    components: {
      Multiselect,
      RangeDatePicker,
      'ag-grid-vue': AgGridVue,
      FloatInput,
      SaveColumnsBtn
    },
    data() {
      return {
        statuses: [{text: 'Active', key: 'active'}, {text: 'Completed', key: 'completed'}],
        payment_type: [{text: 'Cash', key: 'cash'}, {text: 'Non-cash', key: 'non-cash'}],
        refund: [{key: true, text: 'only'}, {key: false, text: 'besides'}],
        paymentForms: [{name: 'Official', key: 'official'}, {name: 'Additional', key: 'additional'}],
        lc_costs: [
          {
            text: 'only',
            key: false
          },
          {
            text: 'besides',
            key: true
          }
        ],
        excel_report: '',
        searchData: {
          rangeDate: null,
          statuses: [],
          payers: [],
          payment_type: [],
          payment_number: null,
          total: null,
          recipients: [],
          currencies: [],
          money_flow: [],
          refund: [],
          mode: [],
          zero_lc: null
        },
        searchObject: {
          limit: 100,
          offset: 0
        },
        paginationState: true,
        currentPaginateIndex: 1
      }
    },
    computed: {
      ...mapState('woodware', ['partners']),
      ...mapState('payments', ['gridName', 'money_flow', 'reports', 'totalData']),
      ...mapGetters('payments', {
        gridOptions: 'gridOptions',
        payments: 'payments',
        columns: 'columns',
        paymentsCount: 'paymentsCount'
      }),
      ...mapState('generic', ['currencies', 'currentRoutePermissions']),
      countOfViewPayments() {
        return this.payments.length;
      }
    },
    methods: {
      async updateTotalData(event) {
        await this.updateTotalDataWith(event, async (params) => {
          await this.$store.dispatch('payments/updateTotalPayments', params);
        })
      },
      async search() {
        this.gridOptions.api.showLoadingOverlay();
        this.currentPaginateIndex = 1;
        this.searchObject = this.getSearchParams();
        try {
          await this.$store.dispatch('payments/loadPayments', this.searchObject);
          saveFilters('payments', this.searchData);
        } finally {
          this.gridOptions.api.hideOverlay();
        }
      },
      getSearchParams() {
        return {
          ...this.searchObject,
          payment_date_between_after: transformDateFromDateRangeToStringFormatByIndex(this.searchData.rangeDate, 0),
          payment_date_between_before: transformDateFromDateRangeToStringFormatByIndex(this.searchData.rangeDate, 1),
          statuses: getArrayByProperty(this.searchData.statuses, 'key').toString(),
          payers: getArrayByProperty(this.searchData.payers, 'id').toString(),
          money_flow: this.searchData.money_flow.toString(),
          payment_type: getArrayByProperty(this.searchData.payment_type, 'key').toString(),
          payment_number: this.searchData.payment_number,
          recipients: getArrayByProperty(this.searchData.recipients, 'id').toString(),
          total: this.searchData.total,
          refund: this.searchData.refund ? this.searchData.refund.key : '',
          zero_lc: this.searchData.zero_lc && this.searchData.zero_lc.key,
          mode: getArrayByProperty(this.searchData.mode, 'key').toString(),
          currencies: getArrayByProperty(this.searchData.currencies, 'id').toString()
        }
      },
      create() {
        this.$router.push({path: `/payments/new`});
      },
      deletePayments() {
        const id = getArrayByProperty(this.gridOptions.api.getSelectedRows(), 'id');
        if (id.length) {
          this.$http.delete(`partner/payments/`, {body: {id}}).then((response) => {
            this.$notify(setNotifyData('', response.body, 'success'));
          }).then(() => {
            this.currentPaginateIndex = 1;
            this.$store.dispatch('payments/loadPayments', this.searchObject);
          }, (response) => {
            this.$notify(setNotifyData('Error', response.body.Error[0], 'error'));
          });
        } else {
          this.$notify(setNotifyData('Select payments for removing', '', 'warn'));
        }
      },
      cleanFilters() {
        cleanFilters(this.searchData);
      },
      setQuickFilter(e) {
        this.gridOptions.api.setQuickFilter(e.target.value);
      },
      goToPayment(params) {
        if (params.data.id) {
          this.$router.push({path: `/payments/${params.data.id}`})
        }
      },
      loadExcelReport(report) {
        const params = this.getSearchParams();
        this.$http.get(`partner/payments/generate_report/${report.key}/`, {
          responseType: 'blob', params: params
        }).then((response, headers) => {
          const disposition = response.headers.get('content-disposition'),
            fileName = getFileNameFromContentDisposition(disposition, report.value);
          saveAs(response.body, fileName);
        })
      },
      togglePagination() {
        if (!this.paginationState) {
          delete this.searchObject.limit;
          delete this.searchObject.offset;
        } else {
          this.searchObject.limit = 100;
          this.searchObject.offset = 0;
        }
        this.search();
      },
      changePaginateState() {
        const searchObject = {...this.searchObject, offset: (this.currentPaginateIndex - 1) * this.searchObject.limit};
        this.$store.dispatch('payments/loadPayments', searchObject);
      }
    },
    beforeMount() {
      this.$store.dispatch('woodware/getPartners', {is_active: true});
      this.$store.dispatch('generic/getCurrencies');
      this.$store.dispatch('payments/loadPaymentsReports');
      if (checkSavedFilterData('payments')) {
        this.searchData = setFilters('payments');
      }
    }
  }
</script>

<style scoped>
  .search-form__filters, .search-form {
    margin-bottom: 15px;
  }

  .grid {
    height: calc(100vh - 470px);
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/modules/accounts/payments/PaymentList.vue